export default __webpack_public_path__ + "static/media/edit_pencile_outline.06093498.svg";